import { Component, OnInit, OnDestroy, Inject, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonModule, DOCUMENT } from '@angular/common';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SchemaService } from '../../../shared/services/schema.service';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule, RouterModule, CarouselModule, CarousalPageComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit, OnDestroy {
  environment: any = environment;
  achievementData: any;
  coreValuesData: any;
  ourJourney: any;
  whyLuminous: any;
  leaders: any;
  aboutData: any;
  sub: Subscription = new Subscription();
  BreadcrumbList: any = [];
  actualSchemaValue: any;
  script: any;
  constructor(public utils: UtilsService, private route: ActivatedRoute, private metaSvc: MetaMgmtService, private jsonDataService: JsonDataService, public router: Router, @Inject(DOCUMENT) private _document: Document,
    private schemaService: SchemaService, private _renderer2: Renderer2, private sanitizer: DomSanitizer,) {
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()

        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
      },
      error: (err: any) => {
        this.utils.hideLoading()
        console.error('Error fetching meta data', err);
      }
    }));
    this.getJsonData();
  }


  selectedYearData: any = {
    heading: '',
    description: '',
  };
  selectedYearIndex: number = 0;
  showAchievement: boolean = false;

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 600,

    nav: true,
    stagePadding: 50,
    margin: 25,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      768: {
        items: 3
      },
      1000: {
        items: 4
      },
    },
    // nav: true
  };

  ngOnInit(): void {
    this.getJsonData();
    if (!this.isSchemaAdded()) {
      this.callSchema();
    }
  }
  private isSchemaAdded(): boolean {
    // Check if schema is present in the document
    const existingSchema = this._document.querySelector('script[type="application/ld+json"]');
    return !!existingSchema; // Returns true if schema is present, false otherwise
  }
  async callSchema() {
    // Call the addBreadcrumbSchema method to generate dynamic breadcrumbs
    const breadcrumbs = this.schemaService.addBreadcrumbSchema(); // No need to pass hardcoded breadcrumbs

    // Convert the schema to a JSON string
    const jsonString = JSON.stringify(breadcrumbs);

    // Create a script element for the JSON-LD
    this.script = this._renderer2.createElement('script');
    this.script.type = 'application/ld+json';
    this.script.text = jsonString; // Directly assign the JSON string
    this.script.defer = true;
    // Append the script to the document's body
    this._renderer2.appendChild(this._document.body, this.script);
  }
  getJsonData() {
    this.sub.add(this.jsonDataService.getAboutUsJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()

        this.achievementData = res.achievementData;
        this.coreValuesData = res.coreValuesData;
        this.ourJourney = res.ourJourney;
        this.whyLuminous = res.whyLuminous;
        this.leaders = res.leaders;
        this.aboutData = res.aboutData;
        if (this.ourJourney && this.ourJourney != undefined && this.ourJourney != null && this.ourJourney.length > 0) {
          this.yearHandler(0); // Assuming you want to initialize with the first element
        }
      },
      error: (err: any) => {
        this.utils.hideLoading()
      }
    }));
    this.utils.showHeaderFooter.next(true);

  }

  yearHandler(index: number) {
    this.selectedYearData.heading = this.ourJourney[index].heading;
    this.selectedYearIndex = index;
  }

  achievementHandler(flag: boolean) {
    this.showAchievement = flag;
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
